<script setup lang="ts">
// Ledger §C defect 3 (ORP-18613): a booted account with a package but zero workspaces used to
// render an empty `<main>` (legacy DefaultLayout.vue:22 `<slot v-else-if="!controlNewWorkspace">`).
// The shell owns this content-area state, so it renders a real empty state instead of nothing.
import { useI18n } from '@/shared/i18n'

const { t } = useI18n()
</script>

<template>
  <section
    class="workspace-empty grid min-h-[60dvh] place-items-center p-lg"
    data-testid="workspace-empty"
    aria-live="polite"
  >
    <div
      class="workspace-empty__card grid w-[min(100%,32rem)] gap-sm rounded-2xl border border-border bg-surface p-[clamp(var(--ui-space-lg),4vw,3rem)] text-center shadow-card"
    >
      <h2 class="workspace-empty__title m-0 text-xl text-fg">
        {{ t('shell.workspace.emptyTitle') }}
      </h2>
      <p class="workspace-empty__description m-0 leading-[1.6] text-muted">
        {{ t('shell.workspace.emptyDescription') }}
      </p>
    </div>
  </section>
</template>
